// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"fbff91b7","498":"a60ba99d","703":"d990a2bc"}[chunkId] + ".chunk.js";
};